export default __webpack_public_path__ + "static/media/PinPin.a4340f12.jpg";